import { reducer as notifications } from 'react-notification-system-redux';
import { combineReducers } from 'redux';
import authReducer from './authReducer';
import errorReducer from './errorReducer';
import paymentReducer from './paymentReducer';

export default combineReducers({
	auth: authReducer,
	error: errorReducer,
	paymentDetails: paymentReducer,
	notifications
});



// WEBPACK FOOTER //
// ./src/reducers/index.js